module.exports = __webpack_public_path__ + "bbda45790bfa4d90266d68b06be7d06c.pdf";